import { INameId } from '@modeso/types__aumico-lib-core-be';

export interface IInputOptionsFormValue {
    text: string;
    dataType: INameId;
    numberOfDecimalPlaces?: INameId;
    compareYears: boolean;
    useAsParameter: boolean;
    parameterName?: string;
    title: string;
}
